module.exports = __webpack_public_path__ + "static/media/inspect_normal_black_circle_blue_m.d20678ee.png";